import { Button } from "@/shared/ui/button.tsx";
import { Input } from "@/shared/ui/input.tsx";
import { Loader2, Sparkles, X } from "lucide-react";
import { AnimatePresence, motion } from "motion/react";
import { SetStateAction, useContext, useEffect, useRef } from "react";
import { useRegenerateEvent } from "../api/unreviewed-api";
import { ApprovalContext, ApprovalContextType } from "../context";
import { useAtomValue } from "jotai";
import { themeAtom } from "@/features/app-layout/atoms/theme-atoms";

type Props = {
  edit: boolean,
  setEdit: React.Dispatch<SetStateAction<boolean>>,
  event_id: number,
  setIsPromptLoading: React.Dispatch<SetStateAction<boolean>>,
}

const EditPrompt = ({ edit, setEdit, event_id, setIsPromptLoading }: Props) => {

  // const { generateImage } = useGetCreatedEventImage()

  const { setImageLoader } = useContext<ApprovalContextType>(ApprovalContext)

  const { regenerateEvent, status } = useRegenerateEvent(() => {
    setIsPromptLoading(false)
    setEdit(false)
  })

  useEffect(() => {
    if (status === "success") {
      setImageLoader(true)
      // generateImage(event_id)
    }
  }, [status])

  const submitHandler = (prompt: string) => {
    console.log("regenrate called")
    regenerateEvent({ id: event_id, prompt })
    setIsPromptLoading(true)
  }

  const theme = useAtomValue(themeAtom)

  const inputRef = useRef<HTMLInputElement | null>(null)

  return (
    <AnimatePresence>
      {edit && (
        <motion.div
          initial={{ translateY: -50, opacity: 0 }}
          animate={{ translateY: 0, opacity: 1 }}
          exit={{ translateY: -50, opacity: 0 }}
          transition={{ ease: "linear" }}
          className="w-full bg-white p-3 border-gray-100 z-10 border shadow rounded-md flex flex-col gap-2">
          <Input className="" placeholder="Enter prompt" ref={inputRef} />
          <section className="flex items-center justify-end gap-3">
            <Button 
              style={{ backgroundColor: theme.primary }}
              className="h-7 text-sm flex items-center gap-2 disabled:bg-gray-600"
              disabled={status === "pending"}
              onClick={() => {
                if (inputRef && inputRef.current) {
                  submitHandler(inputRef.current.value)
                }
              }}>
              {status === "pending" ? <Loader2 className="animate-spin" />  : <Sparkles /> }
              Regenerate</Button>
            <Button className="text-sm h-7" variant="outline" onClick={() => setEdit(false)}>
              <X />
            </Button>
          </section>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default EditPrompt;
